import { OrganizationManagerPagination, OrganizationManagerUser } from 'model/organizationManager';

export interface OrganizationManagerState {
    status: OrganizationManagerStatus;
    loading: boolean;
    error?: string;
    savedOrganizationManager?: OrganizationManagerUser;
    organizationManagers: Array<OrganizationManagerUser>;
    pagination?: OrganizationManagerPagination;
}

export enum OrganizationManagerStatus {
    // eslint-disable-next-line no-unused-vars
    Initial,
    // eslint-disable-next-line no-unused-vars
    Error,
    // eslint-disable-next-line no-unused-vars
    Fetching,
    // eslint-disable-next-line no-unused-vars
    FetchSuccess,
    // eslint-disable-next-line no-unused-vars
    Saving,
    // eslint-disable-next-line no-unused-vars
    SaveSuccess,
    // eslint-disable-next-line no-unused-vars
    Deleting,
    // eslint-disable-next-line no-unused-vars
    DeleteSuccess
}
